import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { MantineProvider } from "@mantine/core";
import { darkTheme } from "./dark/theme";
import { lightTheme } from "./light/theme";
const MantineProviderStatic = ({ children, type, isEnabled = true, }) => {
    return isEnabled ? (_jsx(MantineProvider, { withGlobalStyles: false, withNormalizeCSS: false, theme: type === "light"
            ? { ...lightTheme, globalStyles: undefined }
            : { ...darkTheme, globalStyles: undefined }, children: children })) : (_jsx(_Fragment, { children: children }));
};
export default MantineProviderStatic;
